module.exports = __webpack_public_path__ + "img/avatar-5.b204cc2c.jpg";